var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-message',{attrs:{"type":"is-warning","has-icon":""}},[_vm._v(_vm._s(_vm.$t('geolocation.error'))+" "+_vm._s(_vm.message))])}
var staticRenderFns = []

export { render, staticRenderFns }